var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto max-w-xs pt-8"},[(_vm.subscription)?_c('pause-deliveries',{attrs:{"subscriptionId":_vm.subscriptionId,"addressId":_vm.addressId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }